import { Container, Row, Col } from "react-bootstrap";
import navIcon1 from "../assets/img/nav-icon1.svg";        // LinkedIn
import navIcon2 from "../assets/img/github.icon.svg";       // GitHub

export const Footer = () => {
  return (
    <footer className="footer py-5">
      <Container>
        <Row>
          {/* Single centered column */}
          <Col xs={12} className="text-center">
            
            {/* Social Icons – Centered */}
            <div className="social-icon d-flex justify-content-center gap-4 mb-4">
              <a
                href="https://www.linkedin.com/in/mfobe-ntintelo-635440140/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <img src={navIcon1} alt="LinkedIn" className="social-img" />
              </a>
              <a
                href="https://github.com/MfobesTechJournal"
                target="_blank"
                rel="noreferrer"
                aria-label="GitHub"
              >
                <img src={navIcon2} alt="GitHub" className="social-img" />
              </a>
            </div>

            {/* Copyright – Centered */}
            <p className="mb-0 text-muted small">
              Copyright © {new Date().getFullYear()} Mfobe Ntintelo. All Rights Reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};